import { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import ClientContext from 'contexts/ClientContext'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import classNames from 'classnames'
import './Datepicker.scss'

const Datepicker = ({
  className,
  error,
  isTimepickerShown,
  minDate,
  maxDate,
  onBlur,
  onChange,
  placeholder,
  value,
  ...props
}) => {
  const { t } = useTranslation()
  const [selectedDate, setSelectedDate] = useState(new Date())
  const { color } = useContext(ClientContext)

  const weekdays = [
    t('widget:calendar.days.monday'),
    t('widget:calendar.days.tuesday'),
    t('widget:calendar.days.wednesday'),
    t('widget:calendar.days.thursday'),
    t('widget:calendar.days.friday'),
    t('widget:calendar.days.saturday'),
    t('widget:calendar.days.sunday'),
  ]
  const months = [
    t('widget:calendar.months.january'),
    t('widget:calendar.months.february'),
    t('widget:calendar.months.march'),
    t('widget:calendar.months.april'),
    t('widget:calendar.months.may'),
    t('widget:calendar.months.june'),
    t('widget:calendar.months.july'),
    t('widget:calendar.months.august'),
    t('widget:calendar.months.september'),
    t('widget:calendar.months.october'),
    t('widget:calendar.months.november'),
    t('widget:calendar.months.december')
  ]

  const locale = {
    localize: {
      day: n => weekdays[n],
      month: n => months[n],
    },
    formatLong: {
      date: () => 'mm/dd/yyyy',
      dateTime: () => 'mm/dd/yyyy hh:mm',
      time: () => 'hh:mm',
    },
    match: {},
  }

  const handleChange = date => {
    setSelectedDate(date)
    onChange && onChange(date)
  }

  useEffect(() => {
    if (value !== selectedDate) {
      setSelectedDate(value)
    }
  }, [selectedDate, setSelectedDate, value])

  return (
    <ReactDatePicker
      className={classNames(className, error && 'datepicker-error', color && 'colabel')}
      dateFormat={isTimepickerShown ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
      locale={locale}
      maxDate={maxDate || new Date()}
      minDate={minDate}
      onBlur={onBlur}
      onChange={date => handleChange(date)}
      placeholderText={placeholder}
      selected={selectedDate}
      showTimeInput={isTimepickerShown}
      timeInputLabel={t('widget:calendar.time')}
      showMonthDropdown
      showYearDropdown
      value={value}
      {...props}
    />
  )
}

export default Datepicker
